import { useCallback, useEffect, useState } from 'react';
// material
import {
  Card,
  Checkbox,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tabs,
  Tab,
  Typography,
  Grid,
  LinearProgress,
  Divider,
  Button,
  List,
  ListItem,
  ListItemText,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  IconButton,
  TextField,
  Tooltip
} from '@mui/material';
import { Box } from '@mui/system';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
// components
import EventNoteIcon from '@mui/icons-material/EventNote';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { format } from 'date-fns';
import { PayoutApi } from '../../utils/Apis';
import CustomInput from '../../components/CustomInput';
import Label from '../../components/Label';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserMoreMenu } from '../../components/_dashboard/user';
import { fDate, fDateNew } from '../../utils/formatTime';
import { NOT_AVAILABLE } from '../Global/Constants';
import PayoutToolbar from './PayoutToolbar';
import { getPayoutList } from '../../store/Slice/Payout/PayoutSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { isValidValue, normalizeValue } from '../../utils/CommonFunction';
import usePayoutSelector from '../../store/Slice/Payout/PayoutSelector';
import {
  downloadApiData,
  getMasterListType,
  saveApiData
} from '../../store/Slice/Global/GlobalSlice';
import { StyledTableCell, StyledTableRow } from '../../utils/StyleTable';
import SimplePagination from '../../components/SimplePagination';
import useDebounce from '../../utils/useDebounce';
import BrudCrumbs from '../../components/BreadCrumbs';
import { setApiError } from '../../store/Slice/Error/ErrorSlice';
import Summary from './Summary';
import Network from './Network';
import PandL from './PandL';
import Profile from './Profile';

const TABLE_HEAD = [
  { id: 'leadId', label: 'Application Id', alignRight: false },
  { id: 'lanId', label: 'File No.', alignRight: false },
  { id: 'created', label: 'Submission Date', alignRight: false },
  { id: 'bankName', label: 'Bank Name', alignRight: false },
  { id: 'city', label: 'City', alignRight: false },
  { id: 'name', label: 'Borrower Name', alignRight: false },
  { id: 'loanType', label: 'Loan Type', alignRight: false },
  { id: 'monthName', label: 'Disb Month', alignRight: false },
  { id: 'amount2', label: 'Disbursed Amount', alignRight: false },
  { id: 'sourceFlag', label: 'File Source ', alignRight: false },
  { id: 'partnerName', label: 'Partner', alignRight: false },
  { id: 'payoutStatus', label: 'Status', alignRight: false },
  { id: 'created', label: 'Last update', alignRight: false },
  // { id: 'companyName', label: 'Company Name', alignRight: false },
  // { id: 'contactNumber', label: 'Contact Number', alignRight: false },
  // { id: 'dsaName', label: 'DSA Name', alignRight: false },
  { id: 'action', label: 'ACTION' }
];

export default function PayoutList() {
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState();
  const [filterName, setFilterName] = useState('');
  const [order, setOrder] = useState('desc');
  const [page1, setPage1] = useState(1);
  const [selectStatus, setSelectStatus] = useState(' ');
  const [filterParameter, setFilterParameter] = useState({
    bankId: null,
    bankName: null,
    cityId: null,
    loanTypeId: null
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [RaiseAdavance, setRaiseAdvance] = useState(false);
  const [raiseAdvanceData, setRaiseAdvanceData] = useState(null);

  const [advanceFormData, setAdvanceFormData] = useState({
    advanceAmount: '',
    purpose: ''
  });

  const [isSubmittingAdvance, setIsSubmittingAdvance] = useState(false);

  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();
  const { PayoutListData } = usePayoutSelector();
  const debouncedSearch = useDebounce(filterName, 600);

  // console.log('PayoutListData List Data', PayoutListData);
  // console.log('raiseAdvanceData List Data', raiseAdvanceData);
  // console.log('selected Data', selected);
  const navigate = useNavigate();

  const handleRequestSort = (event, property) => {
    if (property !== 'action') {
      setOrder(orderBy === property && order === 'asc' ? 'desc' : 'asc');
      setOrderBy(property);
    }
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = PayoutListData?.map((n) => n?.partnerPayoutId);
      // console.log('newSelecteds', newSelecteds);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - PayoutListData.length) : 0;

  const handleClick = (event, name) => {
    // Extract the ID from the item object
    const itemId = name?.partnerPayoutId || name;
    // console.log('selected item', itemId);
    const selectedIndex = selected.indexOf(itemId);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, itemId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  // Master Type List
  const getMasterTypeListApi = () => {
    const type = 'PAYOUT_STATUS_TYPE';
    dispatch(getMasterListType(type));
  };

  const getPayoutListApi = useCallback(() => {
    // alert('Get Payout List Api called');
    const credentials = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      accessLevelId: LoginData?.accessLevelId,
      entityListRequestModel: {
        pageNumber: page + 1,
        pageSize: rowsPerPage,
        searchLiteral: debouncedSearch?.length >= 2 ? debouncedSearch : null,
        sortOrder: order
      },
      filterModel: {
        // bankId: filterParameter?.bankId || null,
        bankId: filterParameter?.bankId || null,
        cityId: filterParameter?.cityId || null,
        loanTypeId: filterParameter?.loanTypeId || null
      },
      filterPayoutStatusId: isValidValue(selectStatus) ? selectStatus : null
    };
    dispatch(getPayoutList(credentials));
  }, [
    LoginData,
    page1,
    rowsPerPage,
    debouncedSearch,
    order,
    selectStatus,
    filterParameter,
    dispatch,
    page
  ]);

  useEffect(() => {
    getPayoutListApi();
  }, [getPayoutListApi]);

  useEffect(() => {
    getMasterTypeListApi();
  }, []);

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };
  useEffect(() => {
    if (!PayoutListData) {
      setHasNextPage(true);
      return;
    }
    // If API returned fewer rows → last page
    setHasNextPage(PayoutListData.length >= rowsPerPage);
  }, [PayoutListData, rowsPerPage]);

  useEffect(() => {
    setPage(0);
  }, [debouncedSearch]);

  const handleRaiseAdvanceRequest = useCallback((rowId) => {
    // console.log('Raise Advance Request for row:', rowId);
    setRaiseAdvanceData(rowId);
    setRaiseAdvance(true);
    // Implement the logic to raise an advance request here
  }, []);

  const RaiseAdvanceRequestOperation = useCallback(async () => {
    // Validate inputs
    if (!advanceFormData.advanceAmount || !advanceFormData.purpose) {
      alert('Please fill all required fields');
      return;
    }

    const amount = Number(advanceFormData.advanceAmount);

    if (Number.isNaN(amount) || amount <= 0) {
      alert('Please enter a valid advance amount');
      return;
    }

    setIsSubmittingAdvance(true);
    const finalData = {
      partnerId: raiseAdvanceData?.partnerId,
      payoutId: raiseAdvanceData?.partnerPayoutId || null,
      requestAmount: parseInt(advanceFormData.advanceAmount, 10),
      purpose: advanceFormData.purpose,
      userId: LoginData?.userId
    };

    try {
      const res = await dispatch(saveApiData(PayoutApi?.raiseAdavancePayout, finalData));

      // console.log('Response from raise advance payout API:', res);

      if (res?.requestDate) {
        // Reset form
        setAdvanceFormData({ advanceAmount: '', purpose: '' });
        setRaiseAdvance(false);
        // Refresh the payout list
        getPayoutListApi();
        dispatch(setApiError('Advance request submitted successfully!'));
      } else {
        dispatch(setApiError(res?.payload?.message || 'Failed to submit advance request'));
      }
    } catch (error) {
      console.error('Error submitting advance request:', error);
      dispatch(setApiError('Error submitting advance request. Please try again.'));
    } finally {
      setIsSubmittingAdvance(false);
    }
  }, [advanceFormData, raiseAdvanceData, LoginData, dispatch, getPayoutListApi]);

  const handleDownload = async (type) => {
    const credentials = {
      userId: LoginData?.userId,
      companyId: LoginData?.companyId,
      selectedPayoutIds: selected,
      filters: {
        bankId: filterParameter?.bankId,
        cityId: filterParameter?.cityName,
        loanTypeId: filterParameter?.loanTypeName
      }
    };

    try {
      const result = await dispatch(downloadApiData(PayoutApi?.payoutDownload, credentials));

      if (result?.success && result?.data) {
        const fileName = `PayoutDataDownload_${format(new Date(), 'dd-MM-yyyy_HH-mm-ss')}.xlsx`;

        const url = window.URL.createObjectURL(result.data);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        console.error('Download failed:', result.error);
      }
    } catch (error) {
      console.error('Export error:', error);
    }
  };
  return (
    <Page title="Partner Management System || Payout">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Payout List" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            // className="tabOuter"
            aria-label="basic tabs example"
            classes={{ indicator: 'tabIndicator' }}
            sx={{ mb: 1 }}
          >
            <Tab
              label="Summary"
              {...a11yProps(0)}
              classes={{ selected: 'tabSelected', root: 'tabDefault' }}
            />
            <Tab
              label="Payout List"
              {...a11yProps(1)}
              classes={{ selected: 'tabSelected', root: 'tabDefault' }}
            />

            <Tab
              label="P&L"
              {...a11yProps(2)}
              classes={{ selected: 'tabSelected', root: 'tabDefault' }}
            />
            <Tab
              label="Network"
              {...a11yProps(3)}
              classes={{ selected: 'tabSelected', root: 'tabDefault' }}
            />
            <Tab
              label="Profile"
              {...a11yProps(4)}
              classes={{ selected: 'tabSelected', root: 'tabDefault' }}
            />
          </Tabs>
          <TabPanel value={tabValue} index={0}>
            <Card>
              <PayoutToolbar
                parent="payout"
                selectStatus={selectStatus}
                setSelectStatus={setSelectStatus}
                onFilterName={handleFilterByName}
                setFilterParameter={setFilterParameter}
                filterParameter={filterParameter}
                filterName={filterName}
                handleDownload={handleDownload}
              />
              <Scrollbar>
                <TableContainer sx={{ minWidth: 800, height: '50vh', overflow: 'auto' }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={TABLE_HEAD}
                      rowCount={PayoutListData?.length}
                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                      isCheckBox="true"
                    />
                    <TableBody>
                      {PayoutListData?.length > 0 &&
                        PayoutListData?.map((item, index) => {
                          const isItemSelected = selected.indexOf(item?.partnerPayoutId) !== -1;

                          return (
                            <StyledTableRow
                              hover
                              key={index}
                              tabIndex={-1}
                              role="checkbox"
                              selected={isItemSelected}
                              aria-checked={isItemSelected}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={isItemSelected}
                                  onChange={(event) => handleClick(event, item)}
                                />
                              </TableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.applicationId, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.fileNumber, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {isValidValue(item?.fileSubmissionDate)
                                  ? fDate(item?.fileSubmissionDate)
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.bankName, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.cityName, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.borrowerName, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.loanTypeName, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(fDateNew(item?.disburseMonth), NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell
                                align="left"
                                // sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
                              >
                                {normalizeValue(item?.disburseAmount, NOT_AVAILABLE)}
                                {item?.payoutStatus === 'Matched' ? (
                                  <span
                                    style={{
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      gap: 4
                                    }}
                                  >
                                    <Tooltip
                                      title={item?.revenueDisbursedAmount}
                                      placement="left"
                                      arrow
                                    >
                                      <IconButton
                                        size="small"
                                        sx={{
                                          padding: '2px',
                                          fontSize: 14
                                        }}
                                      >
                                        <InfoOutlinedIcon sx={{ fontSize: 16 }} />
                                      </IconButton>
                                    </Tooltip>
                                  </span>
                                ) : (
                                  ''
                                )}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <Label
                                  variant="ghost"
                                  color={
                                    item?.sourceFlag === 'LOGIN_FILE' ||
                                    item?.logInStatusName === 'Rejected'
                                      ? 'warning'
                                      : 'primary'
                                  }
                                  sx={{
                                    opacity: 0.8,
                                    fontWeight: 500
                                  }}
                                >
                                  {normalizeValue(item?.sourceFlag, NOT_AVAILABLE)}
                                </Label>
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.partnerName, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <Label
                                  variant="ghost"
                                  color={
                                    (item?.payoutStatus &&
                                      item?.payoutStatus === 'Not Matched' &&
                                      'error') ||
                                    (item?.payoutStatus &&
                                      item?.payoutStatus === 'MIS' &&
                                      'warning') ||
                                    (item?.payoutStatus &&
                                      item?.payoutStatus === 'Invoice' &&
                                      'warning') ||
                                    (item?.payoutStatus &&
                                      item?.payoutStatus === 'Payment Due' &&
                                      'error') ||
                                    (item?.payoutStatus &&
                                      item?.payoutStatus === 'Paid' &&
                                      'success') ||
                                    'success'
                                  }
                                >
                                  {item?.payoutStatus ? item?.payoutStatus : `${NOT_AVAILABLE}`}
                                </Label>
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {isValidValue(item?.lastUpdated)
                                  ? fDate(item?.lastUpdated)
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>

                              {/* <StyledTableCell align="left">
                                {normalizeValue(item?.companyName, NOT_AVAILABLE)}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {normalizeValue(item?.contactNumber, NOT_AVAILABLE)}
                              </StyledTableCell>
                             

                              <StyledTableCell align="left">
                                {normalizeValue(item?.dsaName, NOT_AVAILABLE)}
                              </StyledTableCell> */}

                              <StyledTableCell align="" width={80}>
                                <UserMoreMenu
                                  rowId={item}
                                  parent="payout"
                                  handleRaiseAdvanceRequest={handleRaiseAdvanceRequest}
                                />
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        })}
                      {/* {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <StyledTableCell colSpan={6} />
                        </TableRow>
                      )} */}
                    </TableBody>
                    {PayoutListData?.length === 0 && (
                      <TableBody>
                        <TableRow>
                          <StyledTableCell
                            align="center"
                            colSpan={TABLE_HEAD.length + 1}
                            sx={{ py: 3 }}
                          >
                            <SearchNotFound searchQuery={filterName} />
                          </StyledTableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>
              <SimplePagination page={page} setPage={setPage} hasNextPage={hasNextPage} />
            </Card>
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <Summary />
          </TabPanel>
          {/* <TabPanel value={tabValue} index={2}>
            <Card>
              <MyTransaction />
            </Card>
          </TabPanel> */}
          <TabPanel value={tabValue} index={2}>
            <Card>
              <PandL />
            </Card>
          </TabPanel>
          <TabPanel value={tabValue} index={3}>
            <Card>
              <Network />
            </Card>
          </TabPanel>
          <TabPanel value={tabValue} index={4}>
            <Card>
              <Profile />
            </Card>
          </TabPanel>
        </Box>
        <Dialog open={RaiseAdavance} fullWidth>
          <DialogTitle className="popupTitle">
            <Typography variant="h6">Raise Advance Request</Typography>
            <IconButton
              onClick={(e) => {
                setRaiseAdvance(false);
                setAdvanceFormData({ advanceAmount: '', purpose: '' });
              }}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={1} mb={2}>
              <Grid item xs={12} sx={{ mb: '1' }} sm={6} md={6}>
                <Typography variant="h6" className="formLabel">
                  File No.
                </Typography>
                <TextField
                  value={raiseAdvanceData?.fileNumber}
                  type="text"
                  variant="outlined"
                  inputProps={{
                    className: 'textInput'
                  }}
                  disabled
                  placeholder="Type Email"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sx={{ mb: '1' }} sm={6} md={6}>
                <Typography variant="h6" className="formLabel">
                  Bank Name
                </Typography>
                <TextField
                  value={raiseAdvanceData?.bankName}
                  type="text"
                  variant="outlined"
                  inputProps={{
                    className: 'textInput'
                  }}
                  disabled
                  placeholder="Type Email"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sx={{ mb: '1' }} sm={6} md={6}>
                <Typography variant="h6" className="formLabel">
                  Borrower Name
                </Typography>
                <TextField
                  value={raiseAdvanceData?.borrowerName}
                  type="text"
                  variant="outlined"
                  inputProps={{
                    className: 'textInput'
                  }}
                  disabled
                  placeholder="Type Email"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sx={{ mb: '1' }} sm={6} md={6}>
                <Typography variant="h6" className="formLabel">
                  Disburse Amount
                </Typography>
                <TextField
                  value={raiseAdvanceData?.disburseAmount}
                  type="text"
                  variant="outlined"
                  inputProps={{
                    className: 'textInput'
                  }}
                  disabled
                  placeholder="Type Email"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sx={{ mb: '1' }} sm={6} md={6}>
                <Typography variant="h6" className="formLabel">
                  Advance Amount *
                </Typography>
                <TextField
                  value={advanceFormData.advanceAmount}
                  onChange={(e) =>
                    setAdvanceFormData({ ...advanceFormData, advanceAmount: e.target.value })
                  }
                  type="number"
                  variant="outlined"
                  inputProps={{
                    className: 'textInput',
                    min: '0',
                    step: '1'
                  }}
                  placeholder="Enter Advance Amount"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Typography variant="h6" className="formLabel">
                  Purpose *
                </Typography>
                <TextField
                  value={advanceFormData.purpose}
                  onChange={(e) =>
                    setAdvanceFormData({ ...advanceFormData, purpose: e.target.value })
                  }
                  fullWidth
                  type="text"
                  multiline
                  rows={3}
                  inputProps={{
                    className: 'textInput'
                  }}
                  placeholder="Enter purpose for advance request"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={RaiseAdvanceRequestOperation}
              variant="contained"
              className="mainBtn"
              disabled={isSubmittingAdvance}
            >
              {isSubmittingAdvance ? 'Submitting...' : 'Submit'}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ paddingTop: '1rem' }}>
          <Card>{children}</Card>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
